"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WSStates = exports.UserType = exports.ChannelType = exports.BusErrors = exports.ClientAdapters = exports.Adapters = void 0;
var Adapters;
(function (Adapters) {
    Adapters["LocalAdapter"] = "LocalAdapter";
    Adapters["GcmAdapter"] = "GcmAdapter";
    Adapters["ScmAdapter"] = "ScmAdapter";
    Adapters["PusherAdapter"] = "PusherAdapter";
    Adapters["RouletteAdapter"] = "RouletteAdapter";
    Adapters["UWSAdapter"] = "UWSAdapter";
})(Adapters = exports.Adapters || (exports.Adapters = {}));
var ClientAdapters;
(function (ClientAdapters) {
    ClientAdapters["PostMessageAdapter"] = "PostMessageAdapter";
    ClientAdapters["FrameResizerAdapter"] = "FrameResizerAdapter";
    ClientAdapters["GravityGatewayAdapter"] = "GravityGatewayAdapter";
})(ClientAdapters = exports.ClientAdapters || (exports.ClientAdapters = {}));
var BusErrors;
(function (BusErrors) {
    BusErrors["MissingAdapterOptions"] = "MissingAdapterOptions";
    BusErrors["MissingClientAdapterError"] = "MissingClientAdapterError";
    BusErrors["MissingLocaleError"] = "MissingLocaleError";
    BusErrors["MissingProductNameError"] = "MissingProductNameError";
    BusErrors["MissingProductIdError"] = "MissingProductIdError";
    BusErrors["MissingWheelIdError"] = "MissingWheelIdError";
    BusErrors["MethodNotImplementedError"] = "MethodNotImplementedError";
})(BusErrors = exports.BusErrors || (exports.BusErrors = {}));
var ChannelType;
(function (ChannelType) {
    ChannelType["Product"] = "Product";
    ChannelType["Jackpot"] = "Jackpot";
    ChannelType["Player"] = "Player";
    ChannelType["Device"] = "Device";
})(ChannelType = exports.ChannelType || (exports.ChannelType = {}));
var UserType;
(function (UserType) {
    UserType["Player"] = "Player";
    UserType["Device"] = "Device";
})(UserType = exports.UserType || (exports.UserType = {}));
var WSStates;
(function (WSStates) {
    WSStates[WSStates["CONNECTING"] = 0] = "CONNECTING";
    WSStates[WSStates["OPEN"] = 1] = "OPEN";
    WSStates[WSStates["CLOSING"] = 2] = "CLOSING";
    WSStates[WSStates["CLOSED"] = 3] = "CLOSED";
})(WSStates = exports.WSStates || (exports.WSStates = {}));
//# sourceMappingURL=Types.js.map